import {
  SET_LOADING,
} from 'constants/LoaderConstant';

export function setLoading(loader) {
  return {
    type: SET_LOADING,
    payload: loader
  };
}